import { Box, Typography } from "@mui/material";
import cluppcitoHappy from "../../../Assets/Clupp_Festejo.png";
import Confetti from "react-confetti";
import { useEffect, useState } from "react";

const KeepInsurance = ({ state, setState, field }) => {
  const [run, setRun] = useState(true);

  useEffect(() => {
    setTimeout(() => setRun((r) => !r), 5000);
  }, []);
  return (
    <>
      <Confetti tweenDuration={10000} recycle={run} />
      <Box textAlign="center" width="100%" padding={0}>
        <img
          src={cluppcitoHappy}
          alt="Cluppcito Happy"
          style={{ width: 150, height: 170, marginBottom: 3 }}
        />
        <Typography variant="h6" gutterBottom>
          ¡Gracias por quedarte con Clupp!
        </Typography>
        <Typography variant="body1">
          {`Nos alegra saber que has decidido mantener tu${
            state.isMoreThanOne ? "s" : ""
          } cobertura${state.isMoreThanOne ? "s" : ""}.`}
          <span role="img" aria-label="happy face">
            🤩
          </span>
        </Typography>
        <Typography variant="body1">
          {`Valoramos tu confianza en Clupp y estamos aquí para ayudarte a
          proteger tu${state.isMoreThanOne ? "s" : ""} vehículo${
            state.isMoreThanOne ? "s" : ""
          } y/o gadgets.`}
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: 600, marginTop: "15px" }}>
          ¡Gracias de nuevo por elegirnos!
          <span role="img" aria-label="thumbs up">
            👍🏼
          </span>
        </Typography>
      </Box>
    </>
  );
};
export default KeepInsurance;
